import type { DripsyColor } from "@utils";
import { useSx } from "dripsy";
import AnimatedPressable from "./animated-pressable";
import * as React from "react";

function AmountButton({
  onPress,
  children,
  backgroundColor,
  hitslop,
  bordered,
  disabled,
  accessibilityLabel,
  testID,
}: {
  onPress: () => void;
  children: React.ReactNode;
  icon?: any;
  backgroundColor: DripsyColor;
  hitslop: { top: number; bottom: number; left: number; right: number };
  bordered?: boolean;
  disabled?: boolean;
  accessibilityLabel?: string;
  testID?: string;
}) {
  const sx = useSx();
  return (
    <AnimatedPressable
      testID={testID}
      accessibilityLabel={accessibilityLabel}
      hitSlop={hitslop}
      style={sx({
        backgroundColor,
        width: 36,
        height: 36,
        borderRadius: 100,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
        borderWidth: bordered ? 1 : 0,
        borderColor: "$lightGrey",
        opacity: disabled ? 0.5 : 1,
      })}
      onPress={disabled ? undefined : onPress}
      animate={React.useMemo(
        () =>
          ({ hovered, pressed }) => {

            return {
              transform: [{ scale: disabled ? 1 : (hovered || pressed ? 1.05 : 1) }],
            };
          },
        [disabled]
      )}
      accessibilityRole="button"
      disabled={disabled}
    >
      {children}
    </AnimatedPressable>
  );
}
export default AmountButton;
